
export enum BolUsageTypeCd {
	BILLING = 'Billing',
	SR_UPDATE = 'SRUpdate'}

